"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaginatedEndpoint = exports.paginate = void 0;
const paginate = (endpoint) => {
    return async function* (params) {
        let more = true;
        let cursor = params.cursor;
        while (more) {
            const res = await endpoint({
                ...params,
                cursor: cursor,
                limit: params.limit || 50
            });
            yield res;
            more = res.more;
            cursor = res.cursor;
        }
    };
};
exports.paginate = paginate;
const createPaginatedEndpoint = (endpoint) => {
    return Object.assign(endpoint, {
        paginate: (0, exports.paginate)(endpoint)
    });
};
exports.createPaginatedEndpoint = createPaginatedEndpoint;
